import { deepPurple } from '@mui/material/colors';
import { Box, Card, Grid, Stack, useTheme, Typography } from '@mui/material';

import { useResponsive } from 'src/hooks/use-responsive';

export const DetailWithdrawalFunction = () => {
  const theme = useTheme();
  const deepPurpleColor = deepPurple.A200;

  const smDown = useResponsive('down', 'sm');
  const padding = () => {
    if (smDown) {
      return 2;
    }
    return 3;
  };
  return (
    <Stack mb={smDown ? 5 : 10}>
      <Stack my={5} spacing={2} alignItems="center">
        <Typography
          fontFamily='"Shantell Sans Light", sans-serif'
          sx={{ color: deepPurpleColor }}
          fontSize={18}
          align="center"
          fontWeight="medium"
        >
          Phần mềm quản lý trung tâm thế hệ mới
        </Typography>
        <Typography variant="h2" align="center">
          Nghỉ học - Bảo lưu - Hoàn phí
        </Typography>
        <Stack>
          <Typography variant="body1" align="center" maxWidth={808}>
            Quản lý quy trình nghỉ học, bảo lưu, hoàn phí minh bạch và tự động. CenterUp giúp trung
            tâm giảm rủi ro sai lệch và đảm bảo trải nghiệm phụ huynh – học viên tốt hơn.
          </Typography>
        </Stack>
      </Stack>
      <Stack alignSelf="center" maxWidth={1150}>
        <Grid container justifySelf="center" spacing={4} alignItems="stretch">
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                width: '100%',
                justifySelf: 'center',
                height: '100%',
                background: theme.palette.background.neutral,
                position: 'relative',
              }}
              variant="outlined"
            >
              <Stack height="100%" justifyContent="space-between">
                <Stack zIndex={2} px={padding} pt={padding}>
                  <Typography variant="h5">Tạo đơn nghỉ học và phê duyệt online</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Tạo đơn nghỉ học online, gồm nghỉ thông thường hoặc nghỉ bảo lưu. Trung tâm phê
                    duyệt hoặc từ chối đơn nghỉ, đồng thời ghi nhận các buổi nghỉ tương ứng vào lịch
                    học.
                  </Typography>
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="employee-detail"
                    src="/assets/sub-pages/operation/withdrawal/create.png"
                    zIndex={2}
                    width="100%"
                    alignSelf="center"
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                width: '100%',
                justifySelf: 'center',
                height: '100%',
                background: theme.palette.background.neutral,
              }}
              variant="outlined"
            >
              <Stack height="100%" justifyContent="space-between">
                <Stack px={padding} pt={padding}>
                  <Typography variant="h5">Theo dõi đơn hoàn phí</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Tạo đơn hoàn phí, kiểm tra và phê duyệt online. Phân loại và xử lý theo các
                    phương án hoàn phí toàn phần, một phần, chuyển phí hoặc không hoàn. Hệ thống tự
                    động kiểm tra và lưu lại log minh bạch.
                  </Typography>
                </Stack>{' '}
                <Stack>
                  <Box
                    alignSelf="flex-end"
                    alt="class-dashboard"
                    component="img"
                    width="100%"
                    src="/assets/sub-pages/operation/withdrawal/refund.png"
                    zIndex={2}
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                width: '100%',
                justifySelf: 'center',
                height: '100%',
                background: theme.palette.background.neutral,
              }}
              variant="outlined"
            >
              <Stack height="100%" justifyContent="space-between">
                <Stack px={padding} pt={padding}>
                  <Typography variant="h5">Chuyển phí linh hoạt</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Hệ thống cho phép chuyển toàn bộ hoặc một phần phí chưa sử dụng sang lớp khác,
                    hoặc học viên khác
                  </Typography>
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="class-task"
                    src="/assets/sub-pages/operation/withdrawal/transfer-fee.png"
                    zIndex={2}
                    width="100%"
                    alignSelf="center"
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                width: '100%',
                justifySelf: 'center',
                height: '100%',
                background: theme.palette.background.neutral,
              }}
              variant="outlined"
            >
              <Stack height="100%" justifyContent="space-between">
                <Stack px={padding} pt={padding} width={1}>
                  <Typography variant="h5">Tự động cập nhật học phí</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Đồng bộ dữ liệu bảo lưu, hoàn/chuyển phí với module học phí. Hệ thống tự động
                    tính số buổi còn lại, số dư học phí và ngày hết phí dự kiến.
                  </Typography>
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="class-schedule"
                    src="/assets/sub-pages/operation/withdrawal/auto-update-tuition.png"
                    zIndex={2}
                    width="100%"
                    alignSelf="center"
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
        </Grid>
      </Stack>
    </Stack>
  );
};
